export default "__VITE_ASSET__8rvdg5We__"